import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError } from "@utils/errorHandler";

import { loadAllProducts, loadSingleProduct } from "./ProductsList.slice";

import { loadAllProductsAPI, loadSingleProductAPI } from "./ProductsList.api";

export const LOAD_ALL_PRODUCTS = {
  LOADING: "Load all product loading",
  SUCCESS: "Load all product success",
  ERROR: "Load all product error",
};

export const LOAD_SINGLE_PRODUCT = {
  LOADING: "Load single product loading",
  SUCCESS: "Load single product success",
  ERROR: "Load single product error",
};

function* loadAllProductsWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllProductsAPI, payload);
    yield put(loadAllProducts(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_PRODUCTS.ERROR, error });
  }
}

function* loadSingleProductSagaWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadSingleProductAPI, payload);
    yield put(loadSingleProduct(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_PRODUCT.ERROR, error });
  }
}

export function* loadAllProductsSaga() {
  yield takeLatest(LOAD_ALL_PRODUCTS.LOADING, loadAllProductsWorker);
}

export function* loadSingleProductSaga() {
  yield takeLatest(LOAD_SINGLE_PRODUCT.LOADING, loadSingleProductSagaWorker);
}
